import { WaterWellBase } from './base/water-well-base';

export class WaterWell extends WaterWellBase { }